import React from "react";

import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import LatestStories from "../../../components/Library/LatestStories";
import Privacy from "./Privacy";
import Terms from "./Terms";

var Legal = function Legal() {
  return React.createElement(
    Layout,
    null,
    React.createElement(
      Sidebar,
      null,
      React.createElement(LatestStories, null)
    ),
    React.createElement(
      Content,
      null,
      React.createElement(Privacy, null),
      React.createElement(Terms, null)
    )
  );
};

export default Legal;


// WEBPACK FOOTER //
// ./src/legal/components/Legal/Legal.js